import './neb-booking-login-form';
import '../login/neb-password-form';

import { LitElement, html, css } from 'lit';

import {
  openError,
  openSuccess,
} from '../../../../neb-dialog/neb-banner-state';
import { authenticateBookingUser } from '../../../../neb-redux/actions/booking-session-actions';
import { store } from '../../../../neb-redux/neb-redux-store';
import { baseStyles } from '../../../../neb-styles/neb-styles';
import { CSS_COLOR_GREY_1 } from '../../../../neb-styles/neb-variables';

export const ELEMENTS = {
  loginForm: { id: 'form-login' },
  changePasswordForm: { id: 'change-password-form' },
  iconClose: { id: 'icon-close' },
};

export const ERROR_LOGIN_UNSUCCESSFUL = 'Incorrect email and/or password.';

class NebBookingLoginController extends LitElement {
  static get properties() {
    return {
      __email: String,
      __password: String,
      __formType: String,
      __errorText: String,

      layout: {
        type: String,
        reflect: true,
      },
      bookingAccountInviteId: String,
      redirectTo: String,
      redirectFrom: String,
      emailFromInvite: String,
    };
  }

  static get styles() {
    return [
      baseStyles,
      css`
        :host {
          display: flex;
          flex-direction: column;
        }

        .icon {
          fill: ${CSS_COLOR_GREY_1};
          cursor: pointer;
          height: 24px;
          width: 24px;
        }

        .container-icon {
          display: flex;
          justify-content: flex-end;
          margin: 18px 18px 25px 0;
        }
      `,
    ];
  }

  constructor() {
    super();

    this.__initState();
    this.__initHandlers();
  }

  __initState() {
    this.__email = '';
    this.__errorText = '';
    this.__formType = 'login';
    this.__password = '';

    this.bookingAccountInviteId = '';
    this.redirectTo = '';
    this.redirectFrom = '';
    this.emailFromInvite = '';

    this.layout = '';

    this.__changePasswordCallback = () => {};

    this.onLogin = () => {};

    this.onForgotPassword = () => {};

    this.onCreateAccount = () => {};

    this.onClose = () => {};
  }

  __initHandlers() {
    this.__handlers = {
      inputChanged: (type, value) => {
        switch (type) {
          case 'email':
            this.__email = value;
            break;

          case 'password':
            this.__password = value;
            break;

          default:
        }
      },
      login: async (user, pw) => {
        if (!user && !pw) {
          this.__errorText = ERROR_LOGIN_UNSUCCESSFUL;
          return;
        }
        this.__email = user;
        this.__password = pw;
        const result = await store.dispatch(
          authenticateBookingUser({
            username: this.__email,
            password: this.__password,
          }),
        );

        if (result.changePassword) {
          this.__formType = 'update-password';
          this.__changePasswordCallback = result.changePassword;
        } else if (result.error) {
          this.__errorText = ERROR_LOGIN_UNSUCCESSFUL;
        } else {
          this.onLogin({
            bookingAccountId: result.id,
            bookingAccountInviteId: this.bookingAccountInviteId,
            redirectTo: this.redirectTo,
          });
        }
      },
      passwordChanged: async password => {
        try {
          await this.__changePasswordCallback(password);
          store.dispatch(openSuccess('Password Updated'));
          return this.__handlers.login(this.__email, password);
        } catch (e) {
          store.dispatch(openError('Unable to update password'));
          return undefined;
        }
      },
      close: () => this.onClose(),
      createAccount: () => this.onCreateAccount(),
      forgotPassword: () =>
        this.onForgotPassword({
          ...(this.bookingAccountInviteId
            ? { bookingAccountInviteId: this.bookingAccountInviteId }
            : {}),
          ...(this.redirectTo ? { redirectTo: this.redirectTo } : {}),
          ...(this.redirectFrom ? { redirectFrom: this.redirectFrom } : {}),
        }),
    };
  }

  render() {
    return this.__formType === 'login'
      ? html`
          <neb-booking-login-form
            id="${ELEMENTS.loginForm.id}"
            class="login-form"
            .email="${this.__email}"
            .errorText="${this.__errorText}"
            .layout="${this.layout}"
            .password="${this.__password}"
            .emailFromInvite="${this.emailFromInvite}"
            .onCreateAccount="${this.__handlers.createAccount}"
            .onChange="${this.__handlers.inputChanged}"
            .onLogin="${this.__handlers.login}"
            .onForgotPassword="${this.__handlers.forgotPassword}"
          ></neb-booking-login-form>
        `
      : html`
          <neb-password-form
            id="${ELEMENTS.changePasswordForm.id}"
            class="form"
            .email="${this.__email}"
            .onChangePassword="${this.__handlers.passwordChanged}"
          ></neb-password-form>
        `;
  }
}

customElements.define(
  'neb-booking-login-controller',
  NebBookingLoginController,
);
